import { postNamedQuery } from '../../../../../../service'

export default async function getPersonData (clientId) {
  const query = {
    assignedPeople: {
      includes: {
        personTypes: true,
        profileJSON: true
      },
      filters: {
        assignedToClientIds: [clientId]
      }
    }
  }

  const response = await postNamedQuery('levels', 'search-assigned-people-multiple', query)
  const people = response?.data?.assignedPeople?.data ?? []

  return people.map((person) => ({
    ...person,
    levelId: person.personId,
    levelTypeId: 200,
    entityLevelTypeId: 200,
    label: person.fullName || `${person.firstName} ${person.lastName}`.trim(),
    description: person.personType?.name,
    familyTreeDepth: person.personType?.familyTreeDepth ?? 0,
    id: person.personId
  }))
}
